import {
    FETCH_DISTRIBUTION_STRIP_START,
    FETCH_DISTRIBUTION_STRIP_SUCCESS,
    FETCH_DISTRIBUTION_STRIP_FAIL,

} from "../../../constants";
import {
    FETCH_DISTRIBUTION_STRIP_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getDistributionStrip = createVisualizationFetchAction(FETCH_DISTRIBUTION_STRIP_URL, {
    START: FETCH_DISTRIBUTION_STRIP_START,
    SUCCESS: FETCH_DISTRIBUTION_STRIP_SUCCESS,
    FAIL: FETCH_DISTRIBUTION_STRIP_FAIL,
});
